import React, { useEffect } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import routes from "../routes";
import Layout from "./Layout";
import { useOktaAuth } from "@okta/okta-react";
import { isAdmin } from "../lib/oktaConfig";

function withLayout(WrappedComponent) {
  // ...and returns another component...
  return class extends React.Component {
    render() {
      return (
        <Layout>
          <WrappedComponent
            {...this.props.match.params}
          ></WrappedComponent>
        </Layout>
      );
    }
  };
}

const wrappedRoutes = routes.map(route => ({
  ...route,
  wrappedComponent: withLayout(route.component),
}));

const NotFound = () => {
  return <div>Not found</div>;
};

const PrivateRoute = ({ component: Component, ...rest }) => {
  if (rest.forAdmin) {
    return (
      <Route
        {...rest}
        render={(props) =>
          isAdmin() ? <Component {...props} /> : <Redirect to="/logout" />
        }
      />
    );
  } else {
    return <Route {...rest} render={(props) => <Component {...props} />} />;
  }
};

const BaseRoutes = () => {
  const { authState, oktaAuth } = useOktaAuth();

  useEffect(() => {
    if (!authState) return;
    if (!authState.isAuthenticated) {
      oktaAuth.signInWithRedirect();
    }
  }, [authState, oktaAuth]);

  if (!authState || !authState.isAuthenticated) {
    return null;
  }

  return (
    <Switch>
      <Redirect exact from="/" to="/dashboard" />
      {wrappedRoutes.map((route, idx) =>
        route.ispublic ? (
          <Route
            exact
            path={route.path}
            component={route.wrappedComponent}
            key={idx}
          />
        ) : (
          <PrivateRoute
            exact
            path={route.path}
            component={route.wrappedComponent}
            key={idx}
            forAdmin={route.forAdmin}
            isAdmin={isAdmin}
          />
        )
      )}
      <Route path="*" component={NotFound} />
    </Switch>
  );
};

export default BaseRoutes;
